import { ServiceModeStatusEnum } from "./ServiceModeStatusEnum";

export class InstallationServiceModeSwitching {
    public id: number = -1;
    public installationName: string = null;
    public timestamp: Date = null;
    public serviceModeStatus: ServiceModeStatusEnum = ServiceModeStatusEnum.Disabled;

    constructor() {}

    public parse(obj: any) {
        if (obj.Id != null) this.id = obj.Id;
        if (obj.InstallationName) this.installationName = obj.InstallationName;
        if (obj.Timestamp) this.timestamp = obj.Timestamp;
        if (obj.ServiceModeStatus != null && Object.values(ServiceModeStatusEnum).includes(obj.ServiceModeStatus)) this.serviceModeStatus = obj.ServiceModeStatus;
    }
}
